export default __webpack_public_path__ + "static/media/bg2.ce1bc343.jpg";